import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-financing-stepper',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './financing-stepper.component.html',
  styleUrl: './financing-stepper.component.css',
})
export class FinancingStepperComponent {
  steps = [
    {
      title: 'step01.title',
      description: 'step01.text',
      active: true,
    },
    {
      title: 'step02.title',
      description: 'step02.text',
      active: false,
    },
    {
      title: 'step03.title',
      description: 'step03.text',
      active: false,
    },
    {
      title: 'step04.title',
      description: 'step04.text',
      active: false,
    },
  ];

  setActive(index: number): void {
    this.steps.forEach((step, i) => {
      step.active = i === index;
    });
  }
}
